export default __webpack_public_path__ + "static/media/919.d0eb97aa.jpg";